export function shouldDisableExportPdfButton({ disabled, exportConfig }) {
  return Boolean(disabled || !exportConfig);
}
